import React from "react";

const AddButton = () => {
	return (
		<div>
			<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
				<path d='M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z'></path>
			</svg>
		</div>
	);
};

export default AddButton;
